import React, { Component } from 'react';
import { Button } from '@betareader/design-system';
import { withRouter } from 'react-router-dom';
import {
  ContentState, Modifier, SelectionState
} from 'draft-js';

// i18n
import { withTranslation } from 'react-i18next';

// redux
import { push } from '../../navigation';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

export class SplitChapterButton extends Component {
  splitChapter = () => {
    const { editorState } = this.props;
    const currentContentState = editorState.getCurrentContent();
    const currentSelectionState = editorState.getSelection();
    const selectedBlockKey = currentSelectionState.getStartKey();
    const startOffset = currentSelectionState.getStartOffset();
    const selectedBlock = currentContentState.getBlockForKey(selectedBlockKey);
    let updatedContentState = currentContentState;
    let splitBlockKey;

    if (startOffset === 0) {
      splitBlockKey = selectedBlockKey;
    } else if (startOffset === selectedBlock.getLength()) {
      splitBlockKey = currentContentState.getBlockAfter(selectedBlockKey)?.getKey();
    } else {
      const splitSelection = new SelectionState({
        anchorKey: selectedBlockKey,
        anchorOffset: startOffset,
        focusKey: selectedBlockKey,
        focusOffset: startOffset,
        hasFocus: true
      });
      updatedContentState = Modifier.splitBlock(currentContentState, splitSelection);
      splitBlockKey = updatedContentState.getBlockAfter(selectedBlockKey).getKey();
    }

    const blocks = updatedContentState.getBlockMap().toArray();
    const splitIndex = splitBlockKey
      ? blocks.findIndex(block => block.getKey() === splitBlockKey)
      : blocks.length;
    const asContentState = selectedBlocks => selectedBlocks.length
      ? ContentState.createFromBlockArray(selectedBlocks, updatedContentState.getEntityMap())
      : ContentState.createFromText('');

    this.props.onSplit({
      contentAboveSplit: asContentState(blocks.slice(0, splitIndex)),
      contentBelowSplit: asContentState(blocks.slice(splitIndex))
    });
  }

  render() {
    const { t } = this.props;
    return (
      <Button
        variant='ghost'
        size='small'
        aria-label={t('SplitChapter')}
        title={t('SplitChapter')}
        onClick={this.splitChapter}
      >
        <span aria-hidden='true'>✂</span>
      </Button>
    );
  }
}

// redux stuff
const mapStateToProps = state => ({
  user: state.user.user,
  idToken: state.user.idToken,
  currentBook: state.book.currentBook,
  currentChapter: state.book.currentChapter
});

const mapDispatchToProps = dispatch => bindActionCreators({
  changePage: newPage => push(newPage)
}, dispatch);

export default withTranslation()(withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(SplitChapterButton)));
